import { TextAlignment, VerticalAlignment } from './CellTypeConstants';
import { COLORS } from '../colors/colorConstants';

export const TABLE_DISPLAY_NAME = 'Table';

export const TABLE_MIN_WIDTH = 12;
export const TABLE_MIN_HEIGHT = 6;

export const TABLE_CELL_MIN_WIDTH = 4;

export const TABLE_INITIAL_COL_COUNT = 3;
export const TABLE_INITIAL_ROW_COUNT = 4;

export const TABLE_MIN_COL_COUNT = 1;
export const TABLE_MIN_ROW_COUNT = 2;

export const TABLE_DEFAULT_COL_WIDTH = 12;
export const TABLE_DEFAULT_ROW_HEIGHT = 3;

export const TABLE_GRID_EDITOR_KEY = 'TABLE-GRID';
export const TABLE_CELL_EDITOR_KEY = 'TABLE-CELL';
export const TABLE_TITLE_EDITOR_KEY = 'TABLE-TITLE';

export const TABLE_CELL_DEFAULT_TEXT_ALIGNMENT = TextAlignment.LEFT;
export const TABLE_CELL_DEFAULT_VERTICAL_ALIGNMENT = VerticalAlignment.TOP;

// Table colors
export const TABLE_DEFAULT_HEADER_BACKGROUND_COLOR = 'TABLE_DEFAULT_HEADER_BACKGROUND_COLOR';

// Mirrors table background tokens, defined in colors-light-mode.scss/colors-dark-mode.scss.
// body: --color-bg-element-primary, which currently matches --color-bg-primary
// header: --color-bg-table-header (--color-gray-light-mode-200 / --color-gray-dark-mode-700)
// border: the overlay colour used by tableCellBorderUtils for borders on light/dark cell backgrounds.
// Light border maps to --color-gray-light-mode-900, matching the previous rgb(50, 59, 74) value.
// Concrete values come from 20-theme-semantic-colors.css and 90-theme-dark-mode.css, and are used for
// JS-only colour comparisons/mixing. These must be updated by hand whenever those tokens change —
// tableCellBorderUtils mixes cell borders out of them, so drift makes borders vanish into their background.
export const TABLE_DEFAULT_BACKGROUND_COLORS = {
    light: {
        body: '#ffffff',
        header: '#d1d3d6',
        border: '#323b4a',
    },
    dark: {
        body: '#282828',
        header: '#414141',
        border: '#ffffff',
    },
};

export const TABLE_DEFAULT_COLORS = {
    ...COLORS,
    GREY: {
        name: 'TABLE_DEFAULT_HEADER_BACKGROUND_COLOR',
        css: 'var(--ws-table-header-row-background)',
        hex: TABLE_DEFAULT_BACKGROUND_COLORS.light.header,
    },
};
